/* eslint-disable */
import { useRef, useState } from 'react';

export function useDragReorder<T extends { id: number }>(initialItems: T[]) {
  const [items, setItems] = useState(initialItems);
  const draggingIndex = useRef<number | null>(null);
  const startY = useRef<number>(0);
  const currentY = useRef<number>(0);

  const handlePointerDown = (index: number) => (e: React.PointerEvent<HTMLDivElement>) => {
    draggingIndex.current = index;
    startY.current = e.clientY;
    currentY.current = e.clientY;

    const el = e.currentTarget; // 👈 теперь это HTMLDivElement
    el.setPointerCapture(e.pointerId);
    el.style.zIndex = '1000';
    el.style.position = 'relative';
  };

  const handlePointerMove = (index: number) => (e: React.PointerEvent<HTMLDivElement>) => {
    if (draggingIndex.current === null) return;
    currentY.current = e.clientY;
    const delta = currentY.current - startY.current;

    const el = e.currentTarget;
    el.style.transform = `translateY(${delta}px)`;
  };

  const handlePointerUp = (index: number) => (e: React.PointerEvent<HTMLDivElement>) => {
    if (draggingIndex.current === null) return;

    const el = e.currentTarget;
    // сброс стилей
    el.style.transform = '';
    el.style.zIndex = '';
    el.style.position = '';

    const delta = currentY.current - startY.current;
    const itemHeight = el.offsetHeight; // 👈 теперь TS понимает
    const movedBy = Math.round(delta / itemHeight);

    let targetIndex = index + movedBy;
    if (targetIndex < 0) targetIndex = 0;
    if (targetIndex > items.length - 1) targetIndex = items.length - 1;

    if (targetIndex !== index) {
      const newItems = [...items];
      const [moved] = newItems.splice(index, 1);
      newItems.splice(targetIndex, 0, moved);
      setItems(newItems);
    }

    draggingIndex.current = null;
  };

  return {
    items,
    setItems,
    getDragProps: (index: number) => ({
      onPointerDown: handlePointerDown(index),
      onPointerMove: handlePointerMove(index),
      onPointerUp: handlePointerUp(index),
      style: { touchAction: 'none', cursor: 'grab', transition: 'transform 0.2s' },
    }),
  };
}
